import { MutableRefObject, useEffect, useRef } from 'react';

export function useInterval(callback: () => void, delay: number) {
  const savedCallback: MutableRefObject<any> = useRef();

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    if (delay === null) return;
    function tick() {
      savedCallback.current();
    }

    let id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay]);
}
